<template>
  <div class="flex items-center min-h-screen">
    <div class="flex flex-col mx-auto">
      <div class="header">Lo sentimos, página no encontrada.</div>
      <router-link :to="redirectRoute" class="mx-auto mt-8 link">{{ redirectLabel }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    redirectRoute() {
      return this.$store.state.user ? { name: "home" } : { name: "login" };
    },
    redirectLabel() {
      return this.$store.state.user ? "Ir al dashboard" : "Ir a inicio de sesión";
    },
  },
};
</script>
